import { create } from 'zustand';

import type { AnalyticsAdapter } from '@/adapters/analytics/types';
import { ANALYTICS_EVENTS, ANALYTICS_PARAMS } from '@/constants/analytics';

export interface NotificationAnalyticsAdapters {
  analytics: AnalyticsAdapter;
}

export interface NotificationAnalyticsActions {
  trackPushNotificationReceived: () => void;
  trackPushNotificationOpened: (resourceType?: string) => void;
  trackDeepLinkHandled: (resourceType: string) => void;
  trackNotificationPermissionPromptEnabled: () => void;
  trackNotificationPermissionPromptSkipped: () => void;
}

export const createNotificationAnalyticsStore = (adapters: NotificationAnalyticsAdapters) =>
  create<NotificationAnalyticsActions>(() => ({
    trackPushNotificationReceived: () => {
      adapters.analytics.track(ANALYTICS_EVENTS.APP_PUSH_NOTIFICATION_RECEIVED);
    },
    trackPushNotificationOpened: (resourceType?: string) => {
      adapters.analytics.track(ANALYTICS_EVENTS.APP_PUSH_NOTIFICATION_OPENED, {
        [ANALYTICS_PARAMS.RESOURCE_TYPE]: resourceType ?? 'unknown',
      });
    },
    trackDeepLinkHandled: (resourceType: string) => {
      adapters.analytics.track(ANALYTICS_EVENTS.APP_DEEP_LINK_HANDLED, {
        [ANALYTICS_PARAMS.RESOURCE_TYPE]: resourceType,
      });
    },
    trackNotificationPermissionPromptEnabled: () => {
      adapters.analytics.track(ANALYTICS_EVENTS.APP_NOTIFICATION_PERMISSION_PROMPT_ENABLED);
    },
    trackNotificationPermissionPromptSkipped: () => {
      adapters.analytics.track(ANALYTICS_EVENTS.APP_NOTIFICATION_PERMISSION_PROMPT_SKIPPED);
    },
  }));
